import React, { useState } from 'react';
import Counter from '../index';
const Counter3 = () => {
	const [count, setCount] = useState(0);

	const onIncrement = () => {
		setCount(count + 1);
	};
	const onDecrement = () => {
		setCount(count - 1);
	};
	return (
		<div>
			<Counter grey={false} vertical={true} width="52px" handleIncrement={onIncrement} handleDecrement={onDecrement} content={count} />
		</div>
	);
};

export default Counter3;
